import { GridLayout, HorizontalLayout } from "../components/layout";
import ColorPicker, { ColorPickerSidePreview } from "../atoms/colorpicker";

export function ThemeColorPicker({colorName, setColor, colorValue}) {
    return (<GridLayout  gap="0.5" columnsTemplate="1fr auto" className="center-all" style={{"margin": "0px 1rem"}}>
        <p style={{color: "var(--grey-800)", fontSize: "14px", "width": "6rem"}}>{colorName}</p>
        <ColorPicker colorValue={colorValue} setColor={(v) => setColor(v)}/>
    </GridLayout>)
}